var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{attrs:{"options":_vm.options,"placeholder":"请选择群组","props":_vm.propsSetting,"clearable":""},on:{"change":_vm.handleChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }